import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { RouterLinkDirective, TrackingDirective } from '@hyundai/ng-common-lib';

@Component({
    selector: 'ui-m040-c120-contact-model-banner',
    standalone: true,
    templateUrl: './m040-c120-contact-model-banner.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLinkDirective, TrackingDirective],
})
export class M040C130ContactModelBannerComponent {
    primaryButton = input.required<string>();
    primaryButtonText = input.required<string>();
}
